module.exports.config = {
  "declarative": true,

  "render-module": {
    "name": "PieceExternalProviderAppsRenderModule",
    "path": "front/piece-external-provider-apps-render.module"
  },

  "definition": {
    "name": "PieceExternalProviderAppsDefinition",
    "group": "Components",
    "availablePlatforms": ["web", "apps"],
    "description": "External Provider Apps",
    "isNew": false,
    "fields": [
      {
        "name": "providersName",
        "label": "providersName",
        "type": "plainText"
      },
      {
        "name": "apiKey",
        "label": "apiKey",
        "type": "plainText"
      },
      {
        "name": "idBrand",
        "label": "idBrand",
        "type": "plainText"
      },
      {
        "name": "idAlbum",
        "label": "idAlbum",
        "type": "plainText"
      },

      {
        "name": "idWidget01",
        "label": "idWidget01",
        "type": "plainText"
      },
      {
        "name": "idWidget02",
        "label": "idWidget02",
        "type": "plainText"
      },
      {
        "name": "idWidget03",
        "label": "idWidget03",
        "type": "plainText"
      },
      {
        "name": "idWidget04",
        "label": "idWidget04",
        "type": "plainText"
      },
      {
        "name": "idWidget05",
        "label": "idWidget05",
        "type": "plainText"
      },
      {
        "name": "paramWidget01",
        "label": "paramWidget01",
        "type": "plainText"
      },
      {
        "name": "paramWidget02",
        "label": "paramWidget02",
        "type": "plainText"
      },
      {
        "name": "paramWidget03",
        "label": "paramWidget03",
        "type": "plainText"
      },
      {
        "name": "paramWidget04",
        "label": "paramWidget04",
        "type": "plainText"
      },
      {
        "name": "paramWidget05",
        "label": "paramWidget05",
        "type": "plainText"
      }
    ]
  }
};